// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"845":"32e4af83","993":"b2de77ee"}[chunkId] + ".chunk.js";
};